import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import BookADemoButton from '../../ui/BookADemoButton'
// views
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
  subtitleAnimation,
} from '../../../constants/animation'
// assets
import Glow from '../../glows'
import AgenciesImg from '../../../assets/imgs/agencies/agencies.png'

const RPOComponent = () => {
  return (
    <section className='overview-section agencies-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer className='agencies-grid-container'>
          <div>
            <motion.p
              className='overview-title agencies-overview-title'
              variants={titleAnimation}
            >
              Superior Data Intelligence & Branded Talent Attraction Technology
            </motion.p>
            <motion.p
              className='agencies-subtitle'
              variants={subtitleAnimation}
            >
              Run smarter campaigns and prove ROI with client-branded talent
              pipelines.
            </motion.p>
            <motion.p className='description' variants={descriptionAnimation}>
              Pod transforms recruitment marketing by tying campaigns directly
              to candidate outcomes. Agencies can segment talent by skills and
              geography, run programmatic and social campaigns, and deliver
              measurable results in a client-branded environment. With Pod, you
              move from clicks and impressions to hires and retention - making
              your insights indispensable to clients.
            </motion.p>
            <div className='agencies-button-container'>
              <BookADemoButton />
            </div>
          </div>
          <div className='img-container'>
            <img
              className='agencies-image'
              src={AgenciesImg}
              alt='Agencies Presentation'
            />
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default RPOComponent
